import * as Sentry from '@sentry/react';
import { type CancelToken } from 'axios';

import { CANCEL_FETCH_MESSAGE } from 'hb-react/shared/constants/cancelFetch';
import { defaultQueryClient } from 'hb-react/shared/providers/QueryClient';
import { axiosInstance as axios } from 'hb-react/shared/utils/axios';

import { type URLObject } from './types';

export default (URL: URLObject, cancelToken: { token: CancelToken }) =>
  defaultQueryClient.fetchQuery({
    queryKey: [URL.path, URL.params],
    queryFn: () =>
      axios
        .get(URL.path, {
          cancelToken: cancelToken.token,
          params: URL.params,
        })
        .then(({ data }) => ({ id: URL.objectKey, data: { ...data } }))
        .catch((error) => {
          if (error.message === CANCEL_FETCH_MESSAGE) {
            return null;
          }
          Sentry.captureException(error);

          return { id: URL.objectKey, data: null };
        }),
    staleTime: 5000,
  });
